import React from 'react'
import { Modal } from 'react-bootstrap'
// import DetailDoctor from '../DetailDoctor/index'
// import DetailDoctorService from '../Service/DetailDoctorService'
// import PasienService from '../Service/pasienService'
import AppointmentService from '../Service/appointmentService'
// import './detaildoctor.css'
import './appointment.css'
import { config } from '../Config/config'


export default class formInput extends React.Component {

    constructor() {
        super()
        this.state = {
            textJadwal: "Lihat",
            icon: "fa fa-caret-down",
            ketHist: "Sekarang",

            data: {
                // id_doctor: "606440dd2cec8b3624e95b2c",
                id_doctor: localStorage.getItem(config.cariIdDoctor),
                // parent_biodata_id : "6071b0dcf6bd526f18e78252",
            },

            ListCostumer_Relation: [],
            Mode: "",
            ShowModalJanji: false,
            ShowModalBerhasilSimpan: false,

        }
    }

    // loadList = async () => {

    //     const responBio = await DetailDoctorService.getBiodata(this.state.data)
    //     if (responBio.success) {
    //         this.setState({
    //             bioList: responBio.result,
    //         })
    //         {
    //             this.state.bioList.map(data => {
    //                 this.setState({
    //                     image: data.image
    //                 })
    //             })
    //         }
    //     }

    //     const responTreat = await DetailDoctorService.getTreatment(this.state.data)
    //     if (responTreat.success) {
    //         this.setState({
    //             treatList: responTreat.result,
    //         })
    //     }

    //     const responEdu = await DetailDoctorService.getEducation(this.state.data)
    //     if (responEdu.success) {
    //         this.setState({
    //             eduList: responEdu.result,
    //         })
    //     }

    //     const responHist = await DetailDoctorService.getHistory(this.state.data)
    //     if (responHist.success) {
    //         this.setState({
    //             histList: responHist.result,
    //         })

    //         {
    //             this.state.histList.map(data => {
    //                 this.setState({
    //                     faskesList: this.state.faskesList.concat([data.faskesList])
    //                     // locParent: this.state.locParent.concat([data.locParent])
    //                 })
    //             })
    //         }
    //     }

    //     const responLoc = await DetailDoctorService.getLokasi(this.state.data)
    //     if (responHist.success) {
    //         this.setState({
    //             locList: responLoc.result
    //         })
    //         {
    //             this.state.locList.map(data => {
    //                 this.setState({
    //                     price: data.price,
    //                     faskesList: this.state.faskesList.concat([data.namaRS])
    //                     // category: data.category
    //                 })
    //             })
    //         }
    //     }
    //     const resSchedule = await DetailDoctorService.getJadwal(this.state.data)
    //     if (resSchedule.success) {
    //         this.setState({
    //             schList: resSchedule.result
    //         })
    //     }

    //     const resJanji = await PasienService.getAll()
    //     if (resJanji.success) {
    //         this.setState({
    //             relasiList: resJanji.result
    //         })
    //     }

    //     // const responFaskes = await DetailDoctorService.getFaskes(this.state.data)
    //     // if (responFaskes.success) {
    //     //     this.setState({
    //     //         faskesList: responFaskes.result,
    //     //     })
    //     // }
    // }

    // componentDidMount() {
    //     this.loadList()
    // }



    render() {
        const { image, Model, Model2, ShowModalJanji, relasiList, janjiList, bioList, listTreatment, treatList, locList, faskesList, faskes, ListCostumer_Relation,
            cancelHandler, data, List, errors, disabled, Mode } = this.props
        // const { changeHandler } = this.state
        console.log(ShowModalJanji)
        console.log(List)
        console.log(Model)

        return (

            <div class="mb-10">
                {/* {JSON.stringify(listTreatment)}
                {JSON.stringify(Model)} */}

                <Modal show={ShowModalJanji} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        {/* <Modal.Title>{Mode}</Modal.Title> */}
                        <Modal.Title>Buat Janji Dokter</Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        {/* {JSON.stringify(Model)} */}
                        <div class="mb-12">

                            <div class="form-group row">
                                <div class="col-md-12" style={{ paddingTop: 30 }}>
                                    <div class="profile-info-left">
                                        <div class="col-md-3 float-left">
                                            {/* <div class="profile-img">
                                                <a href="#"><img class="avatar" src={image} alt="" /></a>
                                            </div> */}
                                            {List.map(data => {
                                                return (
                                                    <tbody>
                                                        <img class="circle mt-2 ml-1" style={{ width: 100, height: 100 }} src={data.image[0]} alt="" />
                                                    </tbody>
                                                )
                                            })}
                                        </div>

                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="col-md-12">
                                                {List.map(data => {
                                                    return (
                                                        <tbody>
                                                            <h3 class="text">{data._id}</h3>
                                                            <small class="text">{data.spesialis}</small>
                                                            <div class="text">{data.Lama_Pengalaman} tahun pengalaman</div>
                                                            {/* <img class="circle mt-2 ml-1" style={{ width: 100, height: 100 }} src={data.image[0]} alt="" /> */}
                                                        </tbody>
                                                    )
                                                })}



                                                {/* <h3 class="widget-user-username">{data._id}</h3>
                                                <h5 class="widget-user-desc" style={{ textIndent: 10 }}>{data.spesialis}</h5>
                                                <h5 class="widget-user-desc" style={{ textIndent: 10 }}>{data.Lama_Pengalaman} Tahun Pengalaman</h5><br /> */}
                                            </div>

                                        </div>
                                    </div>

                                    <br></br>
                                    {/* <br></br>
                                    <br></br>
                                    <br></br> */}

                                    <label for="customer_id" class="form-label lebar formInput">Konsultasi untuk*</label>
                                    <div class="lebar">
                                        {/* <select class="form-control" id="customer_id" > */}
                                        {/* <select class="form-control" id="customer_id" value={Model2.customer_id} id="customer" onChange={this.props.changeHandler2("customer_id")} > */}
                                        <select class="form-control" id="customer_id" id="customer" onChange={this.props.changeHandler2("customer_id")} >

                                            <option selected hidden>--Pilih--</option>
                                            {
                                                relasiList.map(data => {
                                                    return (
                                                        <option value={data._id}>{data.nama}, {data.hubungan}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <span class="error1">{errors["customer"]}</span>

                                    </div>
                                    {/* <span className="error">* Pasien harus diisi</span> */}

                                    {/* <p class="error ml-3">{errors["customer_id"]}</p> */}

                                    <br></br>
                                    <label for="faskes" class="form-label lebar formInput">Faskes*</label>
                                    <div class="lebar">
                                        {/* <select class="form-control fontFormInput" value={faskes}> */}
                                        {/* <option >{faskes}</option> */}
                                        {/* <select class="form-control" id="faskes_name" > */}
                                        {/* <select class="form-control" id="faskes_name" value={Model2.doctor_office_id} onChange={this.props.changeHandler2("doctor_office_id")}> */}
                                        <select class="form-control" id="faskes_name" onChange={this.props.changeHandler2("doctor_office_id")}>

                                            <option selected hidden>--Pilih--</option>
                                            {
                                                faskesList.map(data => {
                                                    return (
                                                        <option value={data.doctor_office_id}>{data.namaRS}</option>
                                                    )
                                                })
                                            }

                                        </select>
                                    </div>

                                    <br></br>
                                    <label for="appointment_date" class="form-label lebar formInput">Waktu Kedatangan*</label>
                                    <div class="lebar">
                                        {/* <input type="datetime-local" time-format="yyyy-mm-dd" class="form-control" id="appointment_date" disabled={disabled} /> */}
                                        <input type="datetime-local" time-format="yyyy-mm-dd" class="form-control" id="appointment_date" disabled={disabled} onChange={this.props.changeHandler2("appointment_date")} />
                                    </div>
                                    <p class="error1">{errors["tanggal_janji_expired"]}</p>


                                    {/* <br></br> */}
                                    <label for="doctor_office_treatment_id" class="form-label lebar formInput">Tindakan Medis*</label>
                                    <div class="lebar">
                                        {/* <select class="form-control fontFormInput" id="doctor_office_treatment_id" disabled={disabled}> */}
                                        {/* <select class="form-control fontFormInput" id="doctor_office_treatment_id" value={Model2.doctor_office_treatment_id} disabled={disabled} onChange={this.props.changeHandler('doctor_office_treatment_id')} > */}
                                        <select class="form-control fontFormInput" id="doctor_office_treatment_id" disabled={disabled} onChange={this.props.changeHandler2('doctor_office_treatment_id')} >

                                            <option selected hidden>--Pilih--</option>
                                            {
                                                listTreatment.map(data => {
                                                    return (
                                                        <option value={data._id}>{data.treatment[0]}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <span class="error1">{errors["tindakan"]}</span>

                                    </div></div>
                                <br></br>
                            </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        {/* <button type="button" class="btn btn-primary" >Submit</button> */}
                        <button type="button" class="btn btn-primary" onClick={cancelHandler} >Cancel</button>
                        <button type="button" class="btn btn-primary" onClick={this.props.saveHandler}>Submit</button>

                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
